<template>
  <form>
    <div v-for="option in sortOptions" :key="option.value">
      <input :id="`sort${option.name}`" type="radio" name="sortOption"
             :value="option.value" v-model="sortOptionModel">
      <label :for="`sort${option.name}`">
        Sort by {{ option.name }}
      </label>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SortProducts",
  computed: {
    ...mapGetters([
      'sortOption'
    ]),
    sortOptionModel: {
      get() { return this.sortOption },
      set(value) { this.sortProducts(value) }
    }
  },
  data() {
    return {
      sortOptions: [
        {
          name: 'Trending',
          value: 'rank'
        },
        {
          name: 'New',
          value: 'created_at'
        }
      ]
    };
  },
  methods: {
    ...mapActions([
      'sortProducts'
    ])
  }
}
</script>
